<template>
  <div>
    <PCNavbar selectIndex="3"/>
    <MobileNavBar :currentActive="2" />
    <HotService/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import HotService from '@/components/hotService/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    HotService
  },
}
</script>

<style>
</style>